export default [
    {
        path: '/auxiliary/list',
        name: 'auxiliaryRegistersList',
        component: () => import('../views/auxiliary/List.vue'),
        meta: { title: 'sideMenu.auxiliaryRegister', claims: [{ name: 'auxiliaryRegister', crud: 'read' }] }
    },
    {
        path: '/auxiliary/:id/edit',
        name: 'auxiliaryRegistersEdit',
        component: () => import('../views/editors/RegistersEditor.vue'),
        meta: { claims: [{ name: 'auxiliaryRegister', crud: 'update' }] },
        props: (route) => ({ id: Number(route.params.id), isAuxiliary: true }),
    },
    {
        path: '/auxiliary/fieldDetails',
        name: 'auxiliaryFieldDetails',
        component: () => import('../views/administration/dynamicRegisters/FieldsDetails.vue'),
        props: () => ({ fieldDetailsType: 'auxiliaryRegisters' }),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
]
